import * as e from "react";
import s from "../lib/IconBase.es.js";
import t from "../defs/Devices.es.js";
const o = e.forwardRef((c, r) => /* @__PURE__ */ e.createElement(s, { ref: r, ...c, weights: t }));
o.displayName = "DevicesIcon";
const m = o;
export {
  m as Devices,
  o as DevicesIcon
};
